import {Component, Object3D, TextComponent} from '@wonderlandengine/api';
import {GameManagerInstance} from '../managers/gamemanager.js';
import {Blink} from './blink.js';
import {property} from '@wonderlandengine/api/decorators.js';

export class ShowLoading extends Component {
    static TypeName = 'show-loading';

    @property.object({required: true})
    loadingTextObject!: Object3D;

    private loadingText?: TextComponent;
    private isShowing = false;

    start(): void {
        const tempTextComponent = this.loadingTextObject.getComponent(TextComponent);
        if (!tempTextComponent) {
            throw new Error(
                `show-loading(${this.object.name}): loadingTextObject does not have a TextComponent`
            );
        }
        this.loadingText = tempTextComponent;
        this.loadingText.text = 'Loading...';
    }

    private animationCounter = 0;
    update(delta: number): void {
        if (!this.isShowing) {
            return;
        }

        this.animationCounter += delta;

        // if counter reaches or exceeds one second (1000 milliseconds)
        if (this.animationCounter >= 1) {
            this.animationCounter -= 1; // reset the counter

            let dots = '.';
            const currentText = this.loadingText!.text; // replace with method used to get current text
            const dotsCount = (currentText.match(/\./g) || []).length;

            if (dotsCount == 3) {
                this.loadingText!.text = 'Loading'; // replace with method used to set new text
            } else {
                for (let i = 1; i <= dotsCount; i++) {
                    dots += '.';
                }
                this.loadingText!.text = 'Loading' + dots;
            }
        }
    }
    onActivate(): void {
        GameManagerInstance.onPreloading.add(this.showLoading);
    }

    onDeactivate(): void {
        GameManagerInstance.onPreloading.remove(this.showLoading);
    }

    showLoading = () => {
        const position = this.object.getPositionWorld();
        position[1] = 100;
        this.object.setPositionWorld(position);
        this.isShowing = true;
        this.object
            .getComponent(Blink)!
            .startBlink(null, null, true, null, false)
            .catch(console.error);
    };
}
